import * as React from "react";

import { useTranslation } from "../../i18n/custom.i18n";
//import i18next from "../../i18n/i18n.config";

//import robot_details from "../../i18n/translations/en/en.json";

import { parse_text_with_link } from "./details-utils"

export const DescRobot = (props: any) => {

    const { t, i18n } = useTranslation();

    const get_chart_url = () => {
        let chart_url = "https://robodk.com/industrial-robots-charts/index.html?";
        let chart_params = [];

        for (let key in props.data) {
            switch (key) {
                case "A":
                    chart_params.push("d=" + props.data["A"]);
                    break;

                case "R":
                    chart_params.push("rc=" + props.data["R"]);
                    break;

                case "P":
                    chart_params.push("p=" + props.data["P"]);
                    break;

                case "W":
                    chart_params.push("w=" + props.data["W"]);
                    break;

                case "E":
                    chart_params.push("rp=" + props.data["E"]);
                    break;
            }
        };

        return chart_url += chart_params.join("&");
    };

    const get_google_link = () => {
        let google_url = "https://www.google.ca/search?q=";
        let query =
            props.data["N"]
                .replaceAll(/[\s\-\/'\._]/g, "-")
                .replaceAll(/[\(\)#,]/g, "");

        return google_url + query;
    };

    return (
        <>
            {/* Disclaimer for RoboDK objects */}
            {
                props.data.hasOwnProperty("B") && props.data["B"] == "RoboDK" && (
                    <p>
                        {
                            (t('details-desc.robodk'))
                                .replace(/\{name\}/g, props.data["N"])
                        }
                    </p>
                )
            }

            <p>
                {/* Description */}
                {
                    props.data.hasOwnProperty("N") && props.data.hasOwnProperty("A") && props.data["A"] > 0 && props.data.hasOwnProperty("T") && props.data.hasOwnProperty("P") && props.data.hasOwnProperty("R") && (                        
                        (t('details-desc.robot.name'))
                            .replace(/\{name\}/g, props.data["N"])
                            .replace(/\{axes\}/g, props.data["A"])
                            .replace(/\{type\}/g, t('details-desc.item-types-desc.' + props.data["T"]).join(", "))  // props.data["T"]
                            .replace(/\{payload\}/g, props.data["P"])
                            .replace(/\{reach\}/g, props.data["R"])
                    )
                }
                {
                    props.data.hasOwnProperty("N") && props.data.hasOwnProperty("E") && props.data.hasOwnProperty("W") && (
                        " " + (t('details-desc.robot.details'))
                            .replace(/\{name\}/g, props.data["N"])
                            .replace(/\{repeatability\}/g, props.data["E"])
                            .replace(/\{weight\}/g, props.data["W"])
                    )
                }
            </p>

            {/* Applications */}
            {
                <p>
                    {
                        props.data.hasOwnProperty("N") && props.data.hasOwnProperty("AP") && (
                            (t('details-desc.apps'))
                                .replace(/\{name\}/g, props.data["N"])
                                .replace(/\{applications\}/g, t('application.' + props.data["AP"]))
                        )
                    }
                </p>
            }

            {/* Brand */}
            {
                props.data.hasOwnProperty("N") && props.data.hasOwnProperty("B") && (
                    parse_text_with_link(
                        (t('details-desc.brand'))
                            .replace(/\{name\}/g, props.data["N"])
                            .replace(/\{brand\}/g, props.data["B"])
                            .replace(/\{link\}/g,
                                window.Settings.LOCAL_BUILD 
                                    ? 'http://localhost:3001?Lang=' + window.Languages.language + '#filter?name=' + props.data["B"]
                                    : '/' + (window.Languages.language == 'en' ? '' : window.Languages.language + "/") + 'library?n=' + props.data["B"]
                            )
                    )
                )
            }

            {/* Compare with other robots */}
            {
                parse_text_with_link(
                    (t('details-desc.robot.compare'))
                        .replace(/\{name\}/g, props.data["N"])
                        .replace(/\{link\}/g, get_chart_url())
                )
            }

            {/* Browse the library */}
            {
                parse_text_with_link(
                    (t('details-desc.browse'))
                        .replace(/\{link\}/g, (window.Settings.LOCAL_BUILD)
                            ? "http://localhost:3001?Lang=" + window.Languages.language + "&n=" + props.data["F"].split(".", 1)[0]
                            : "/" + (window.Languages.language == "en" ? "" : (window.Languages.language + "/")) + "library?n=" + props.data["F"].split(".", 1)[0])
                )
            }
        </>
    )
};
